import React, { FC, useEffect, useMemo, useState } from "react";
import {
  Button,
  Col,
  Input,
  InputNumber,
  Space,
  Spin,
  Steps,
  Table,
} from "antd";
import { Form } from "antd";
import { Row } from "antd";
import { Tabs } from "antd";
import { Radio } from "antd";
import { DatePicker } from "antd";
import { Select } from "antd";
import dayjs from "dayjs";
import { DeleteOutlined } from "@ant-design/icons";
import { IDocumentFields } from "../../../../interfaces/ICase";
import { Typography } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../../../store/store";
import {
  getDiagnosis,
  getDoctors,
  getStratifications,
} from "../../../../models/ayushmanBSlice";
import { message } from "antd";
import { useUserFunctionalities } from "../../../../utils/UserFunctionalities";
import { findProcedureInMaster } from "../../../../utils/ayushmanTreatmentPlanMapper";
import MedicalInformation from "./MedicalInformation";
import AdmissionInformation from "./AdmissionInformation";
import DocumentUpload from "../PreAuthEchs/DocumentUpload";
import ResponseDocumentUpload from "../PreAuthEchs/ResponseDocumentUpload";

const dateFormat = "DD-MM-YYYY HH:mm:ss";

const { Option } = Select;
const { Step } = Steps;
const { Search } = Input;
const { Text } = Typography;

interface DiagnosisData {
  diagnosis: string;
  // diagnosisId: string;
  diagnosisCode: string;
  type: string;
}

interface Implant {
  implant: {
    id: number;
    name: string;
    amount: number;
    code: string;
  } | null;
  quantity: number | null;
  document: IDocumentFields | null;
}

interface TreatmentPlan {
  speciality: JsonObject;
  procedure: JsonObject;
  stratification: JsonObject;
  numberOfDaysPerUnits: number | null;
  // ichiCode: string;
}

interface JsonObject {
  [key: string]: any;
}

interface DiagnosisOption {
  theCode: string;
  title: string;
}

type PreAuthAyushmanProps = {
  form: any;
  handleGetData: () => void;
  handleModalOpen: any;
  uploadedImplantFileList: any;
  uploadedInvestigationFileList: any;
  uploadedFileColumns: any;
  uploadedImplantFileColumns: any;
  handleSaveConfirmationModal: any;
  isApproved: boolean;
  isApprovedInitiated: boolean;
  treatmentPlansData: TreatmentPlan[];
  diagnosisData: DiagnosisData[];
  setTreatmentPlansData: any;
  setDiagnosisData: any;
  loading: boolean;
  documentTypes: any;
  documentUrls: any;
  handleFileChange: any;
  handleOpen: any;
  documentRequestResponseDocuments: any;
  uploadFileList: any;
  handleSaveData: any;
  activeKey: any;
  documentTypeList?: {
    investigation?: any[];
    implant?: any[];
    [key: string]: any[] | undefined;
  };
};

const PreAuthAyushman: FC<PreAuthAyushmanProps> = ({
  form,
  handleGetData,
  handleModalOpen,
  uploadedFileColumns,
  uploadedImplantFileList,
  uploadedInvestigationFileList,
  uploadedImplantFileColumns,
  handleSaveConfirmationModal,
  isApproved,
  isApprovedInitiated,
  treatmentPlansData,
  diagnosisData,
  setTreatmentPlansData,
  setDiagnosisData,
  loading,
  documentTypes,
  documentUrls,
  handleFileChange,
  handleOpen,
  documentRequestResponseDocuments,
  uploadFileList,
  handleSaveData,
  activeKey,
  documentTypeList,
}) => {
  const admissionDateValue = Form.useWatch("admissionDate", form);
  const { ayushBPreAuth, patients, preAuth } = useSelector(
    (state: RootState) => state
  );
  const dispatch = useDispatch<AppDispatch>();

  const { hasFunctionality } = useUserFunctionalities();

  const procedures = useMemo(() => {
    const p: any = ayushBPreAuth?.preAuth?.procedures;
    if (Array.isArray(p)) return p as any[];
    if (Array.isArray(p?.data)) return p.data as any[];
    if (Array.isArray(p?.content)) return p.content as any[];
    return [] as any[];
  }, [ayushBPreAuth?.preAuth?.procedures]);

  const showImplantSection = useMemo(() => {
    if ((documentTypeList?.implant?.length ?? 0) > 0) return true;
    if ((uploadedImplantFileList?.length ?? 0) > 0) return true;

    return (treatmentPlansData || []).some((plan) => {
      const master = findProcedureInMaster(procedures, plan?.procedure);
      const implantList =
        master?.implants ||
        master?.implantsList ||
        master?.implantList ||
        plan?.procedure?.implants ||
        [];
      const list = Array.isArray(implantList)
        ? implantList
        : Array.isArray(implantList?.data)
          ? implantList.data
          : [];
      return (
        list.length > 0 ||
        String(
          master?.isimplantapplicable ||
            plan?.procedure?.isimplantapplicable ||
            ""
        ).toUpperCase() === "Y" ||
        String(list?.[0]?.implantapplicableyn || "").toLowerCase() === "yes"
      );
    });
  }, [
    documentTypeList?.implant,
    uploadedImplantFileList,
    treatmentPlansData,
    procedures,
  ]);

  const showInvestigationSection = useMemo(() => {
    if ((documentTypeList?.investigation?.length ?? 0) > 0) return true;
    if ((uploadedInvestigationFileList?.length ?? 0) > 0) return true;

    return (treatmentPlansData || []).some((plan) => {
      const master = findProcedureInMaster(procedures, plan?.procedure);
      return (master?.investigations || [])?.length > 0;
    });
  }, [
    documentTypeList?.investigation,
    uploadedInvestigationFileList,
    treatmentPlansData,
    procedures,
  ]);

  /** Specialities for the procedure currently selected in the add form. */
  const [procedureSpecialities, setProcedureSpecialities] = useState<any[]>(
    []
  );
  const stratifications = useMemo(
    () => ayushBPreAuth?.preAuth?.stratifications || [],
    [ayushBPreAuth?.preAuth?.stratifications]
  );
  const doctors = useMemo(
    () => ayushBPreAuth?.preAuth?.doctors || [],
    [ayushBPreAuth?.preAuth?.doctors]
  );
  //   const [treatmentPlansData, setTreatmentPlansData] = useState<TreatmentPlan[]>(
  //     []
  //   );

  const [implantData, setImplantData] = useState<Implant[]>([]);
  const [selectedDoctor, setSelectedDoctor] = useState<any>(null);

  const [isUnspecifiedProcedure, setIsUnspecifiedProcedure] =
    useState<boolean>(false);

  const [newDiagnosis, setNewDiagnosis] = useState<DiagnosisData>({
    diagnosis: "",
    // diagnosisId: "",
    diagnosisCode: "",
    type: "Primary",
  });

  const [diagnosisOptions, setDiagnosisOptions] = useState<DiagnosisOption[]>(
    []
  );
  const [newTreatmentPlan, setNewTreatmentPlan] = useState<TreatmentPlan>({
    speciality: {},
    procedure: {},
    stratification: {},
    numberOfDaysPerUnits: 1,
    // ichiCode: "",
  });

  const [disabledForm, setDisabledForm] = useState(false);
  const [casePreAuthId, setCasePreAuthId] = useState(null);

  const [newImplant, setNewImplant] = useState<
    Omit<Implant, "key" | "no" | "document">
  >({
    implant: null,
    quantity: 1,
  });

  //   const [diagnosisData, setDiagnosisData] = useState<DiagnosisData[]>([]);

  const mapApiResponseToState = (apiResponse: any) => ({
    temperature: apiResponse?.temperature || "",
    pulseRatePerMinute: apiResponse?.pulseRatePerMinute || "",
    height: apiResponse?.height || "",
    weight: apiResponse?.weight || "",
    // bmi: apiResponse?.bmi || "",
    cyanosis: apiResponse?.cyanosis ?? "No",
    pallor: apiResponse?.pallor ?? "No",
    malnutrition: apiResponse?.malnutrition ?? "No",
    oedema: apiResponse?.oedema ?? "No",
    diabetes: apiResponse?.diabetes || "None",
    hypertension: apiResponse?.hypertension || "None",
    heartDisease: apiResponse?.heartDisease || "None",
    stroke: apiResponse?.stroke || "None",
    cancer: apiResponse?.cancer || "None",
    tuberculosis: apiResponse?.tuberculosis || "None",
    asthma: apiResponse?.asthma || "None",
    diet: apiResponse?.diet || "Normal",
    nutrition: apiResponse?.nutrition || "Normal",
    appetite: apiResponse?.appetite || "Normal",
    bowels: apiResponse?.bowels || "Normal",
    allergies: apiResponse?.allergies ?? "No",
    habitsAddictions: apiResponse?.habitsAddictions ?? "No",

    // Convert Dayjs object to string
    // admissionDate: apiResponse?.admissionDate ? parseDate(apiResponse?.admissionDate) : null,
    // surgeryTreatmentStartDate: apiResponse?.surgeryDate ? parseDate(apiResponse?.surgeryDate) : null,
    // admissionDate: apiResponse?.admissionDate ? parseDateSafely(apiResponse?.admissionDate) : "",
    // surgeryDate: apiResponse?.surgeryDate ? parseDateSafely(apiResponse?.surgeryDate) : "",
    admissionDate: apiResponse?.admissionDate
      ? parseDateSafely(apiResponse?.admissionDate)
      : patients?.fetchBasicDetails?.visitInfoResponse?.doa
      ? parseDateSafely(patients?.fetchBasicDetails?.visitInfoResponse?.doa)
      : null,
    surgeryDate: apiResponse?.surgeryDate
      ? parseDateSafely(apiResponse?.surgeryDate)
      : patients?.fetchBasicDetails?.visitInfoResponse?.doa
      ? parseDateSafely(patients?.fetchBasicDetails?.visitInfoResponse?.doa)
      : null,
    admissionType: apiResponse?.admissionType || "Planned",
    medicoLegalCase: apiResponse?.medicoLegalCase || "No",

    // Treatment Information
    // diagnosis: apiResponse?.diagnosis || "",
    // diagnosisType: apiResponse?.diagnosisType || "Primary",
    // speciality: apiResponse?.speciality || "",
    // procedure: apiResponse?.procedure || "",
    // noOfDaysAndUnits: apiResponse?.noOfDaysAndUnits || "",
    // ichiCode: apiResponse?.ichiCode || "",
    doctorName: apiResponse?.doctorName || "",
    doctorRegistrationId: apiResponse?.doctorRegistrationId || "",
    doctorQualification: apiResponse?.doctorQualification || "",
    doctorMobileNo: apiResponse?.doctorMobileNo || "",
  });

  const mapDiagnosisData = (DiagnosisResponse: DiagnosisData[]) => {
    setDiagnosisData(DiagnosisResponse);
  };

  useEffect(() => {
    const match = treatmentPlansData?.some((item) =>
      item?.procedure?.name?.toLowerCase()?.includes("unspecified")
    );
    setIsUnspecifiedProcedure(match);
  }, [treatmentPlansData]);

  useEffect(() => {
    if (
      ayushBPreAuth?.portalData?.casePreAuthOthersResponse?.casePreAuthResponse
        ?.id
    ) {
      setCasePreAuthId(
        ayushBPreAuth?.portalData?.casePreAuthOthersResponse
          ?.casePreAuthResponse?.id || null
      );
      //   setDisabledForm(true);
    }
  }, [
    ayushBPreAuth?.portalData?.casePreAuthOthersResponse?.casePreAuthResponse
      ?.id,
  ]);

  useEffect(() => {
    if (
      ayushBPreAuth?.portalData?.casePreAuthOthersResponse?.casePreAuthResponse
        ?.submitted
    ) {
      setDisabledForm(true);
    }
  }, [
    ayushBPreAuth?.portalData?.casePreAuthOthersResponse?.casePreAuthResponse
      ?.submitted,
  ]);

  useEffect(() => {
    // if (ayushBPreAuth?.portalData) {
    form.setFieldsValue(
      mapApiResponseToState(
        ayushBPreAuth?.portalData?.casePreAuthOthersResponse || {}
      )
    );
    // }
    // treatmentPlansData is hydrated in PreAuthAyushmanContainer from portal data
    if (
      ayushBPreAuth?.portalData?.casePreAuthOthersResponse?.diagnosisData
        ?.length > 0
    ) {
      mapDiagnosisData(
        ayushBPreAuth?.portalData?.casePreAuthOthersResponse?.diagnosisData
      );
    }
  }, [ayushBPreAuth.portalData]);

  useEffect(() => {
    if (
      ayushBPreAuth?.portalData?.casePreAuthOthersResponse
        ?.doctorRegistrationId &&
      doctors
    ) {
      const docValue = doctors?.find(
        (doc) =>
          doc?.docregnum ==
          ayushBPreAuth?.portalData?.casePreAuthOthersResponse
            ?.doctorRegistrationId
      );
      const doctorValue = docValue?.docid || "OTHER";
      setSelectedDoctor(doctorValue);
      form?.setFieldsValue({ selectedDoctor: doctorValue });
    } else if (
      ayushBPreAuth?.portalData?.casePreAuthOthersResponse?.doctorName
    ) {
      setSelectedDoctor("OTHER");
      form?.setFieldsValue({ selectedDoctor: "OTHER" });
    }
  }, [ayushBPreAuth.portalData, doctors, form]);

  const parseDateSafely = (dateString: string) => {
    if (!dateString) return "";

    // Try to parse the date
    const parsed = dayjs(dateString, dateFormat);
    // For DD-MM-YYYY HH:mm:ss format which might not be recognized automatically
    if (!parsed.isValid()) {
      return dayjs(dateString, "DD-MM-YYYY HH:mm:ss");
    }

    return parsed;
  };

  useEffect(() => {
    if (ayushBPreAuth?.preAuth?.diagnosis?.length > 0) {
      setDiagnosisOptions(ayushBPreAuth?.preAuth?.diagnosis);
    } else {
      setDiagnosisOptions([]);
    }
  }, [ayushBPreAuth?.preAuth?.diagnosis]);

  useEffect(() => {
    if (diagnosisData?.length > 0) {
      setNewDiagnosis({
        diagnosis: "",
        // diagnosisId: "",
        diagnosisCode: "",
        type: diagnosisData?.some((item) => item?.type == "Primary")
          ? "Secondary"
          : "Primary",
      });

      form.setFieldValue(
        "diagnosisType",
        diagnosisData?.some((item) => item?.type == "Primary")
          ? "Secondary"
          : "Primary"
      );
    }
  }, [diagnosisData]);

  // Fetch doctors from selected specialities across all treatment plans.
  // Auto-fill speciality only when missing and procedure has exactly one option.
  useEffect(() => {
    if (!treatmentPlansData?.length || !procedures?.length) return;

    const needsEnrich = treatmentPlansData?.some(
      (plan) => !(plan?.speciality?.id || plan?.speciality?.name)
    );

    if (needsEnrich) {
      let didEnrich = false;
      const enriched = treatmentPlansData?.map((plan) => {
        const hasSpeciality = plan?.speciality?.id || plan?.speciality?.name;
        if (hasSpeciality) return plan;

        const master = findProcedureInMaster(procedures, plan?.procedure);
        const specs = master?.specialities || [];
        if (specs?.length === 1) {
          didEnrich = true;
          return {
            ...plan,
            speciality: {
              id: specs?.[0]?.specialityid,
              name: specs?.[0]?.speciality,
            },
          };
        }
        return plan;
      });

      if (didEnrich) {
        setTreatmentPlansData(enriched);
      }
      return;
    }

    const specialityList = treatmentPlansData
      ?.map((item) => item?.speciality?.name)
      ?.filter(Boolean);

    if (
      specialityList?.length > 0 &&
      patients?.fetchBasicDetails?.casesResponse?.portalMetaDataIds?.[0]
    ) {
      dispatch(
        getDoctors({
          portalMetaDataId:
            patients?.fetchBasicDetails?.casesResponse?.portalMetaDataIds?.[0],
          data: { specialityCodes: specialityList },
        })
      );
    }
  }, [
    dispatch,
    patients?.fetchBasicDetails?.casesResponse?.portalMetaDataIds?.[0],
    treatmentPlansData,
    procedures,
    setTreatmentPlansData,
  ]);

  const handleCategorySearch = (value: string) => {
    const lowerCaseValue = value.toLowerCase();
    if (patients?.fetchBasicDetails?.casesResponse?.portalMetaDataIds?.[0]) {
      // const diagnosisList = await fetchDiagnosis(patients?.schemeMetaData?.portalMetaDataIdsList[0], value)
      dispatch(
        getDiagnosis({
          portalMetaDataId:
            patients?.fetchBasicDetails?.casesResponse?.portalMetaDataIds?.[0],
          searchTerm: value,
        })
      );
    }

    form.setFieldsValue({ selectedDiagnosis: null });
    setNewDiagnosis((prev) => ({
      ...prev,
      diagnosis: "",
      // diagnosisId: "",
      diagnosisCode: "",
    }));
  };

  const handleDiagnosisSelect = (theCode: string) => {
    const selectedOption = diagnosisOptions?.find(
      (option) => option.theCode === theCode
    );
    if (selectedOption) {
      setNewDiagnosis({
        ...newDiagnosis,
        diagnosis: selectedOption.title,
        // diagnosisId: selectedOption.diagnosisId,
        diagnosisCode: selectedOption.theCode,
      });
    }
  };

  const handleAddDiagnosis = () => {
    if (
      newDiagnosis.diagnosis &&
      newDiagnosis.diagnosisCode &&
      newDiagnosis.type
    ) {
      setDiagnosisData((prev: any) => [...prev, newDiagnosis]);

      form.setFieldsValue({ selectedDiagnosis: null });
    }
  };

  const handleDeleteDiagnosis = (index: number): void => {
    setDiagnosisData(diagnosisData?.filter((_, i) => i !== index));
  };

  const handleDeleteTreatmentPlan = (index: number): void => {
    setTreatmentPlansData(treatmentPlansData?.filter((_, i) => i !== index));
  };

  const handleDeleteImplant = (index: number): void => {
    setImplantData(implantData?.filter((_, i) => i !== index));
  };

  const handleDoctorChange = (value: any) => {
    if (value === "OTHER") {
      setSelectedDoctor(value);
      form?.setFieldsValue({
        selectedDoctor: value,
        doctorName: undefined,
        doctorRegistrationId: undefined,
        doctorQualification: undefined,
        doctorMobileNo: undefined,
      });
    } else {
      setSelectedDoctor(value);
      const selectedDoc = doctors?.find((doctor) => doctor?.docid === value);
      form?.setFieldsValue({
        selectedDoctor: value,
        doctorName: selectedDoc?.docname || undefined,
        doctorRegistrationId: selectedDoc?.docregnum || undefined,
        doctorQualification: selectedDoc?.docqualification || undefined,
        doctorMobileNo: selectedDoc?.doccontactnumber || undefined,
      });
    }
  };

  const qualificationOptions = [
    { label: "M.B.B.S.", value: "M.B.B.S." },
    { label: "M.D.", value: "M.D." },
    { label: "Master of Surgery (M.S.)", value: "Master of Surgery (M.S.)" },
    {
      label: "Doctorate of Medicine (D.M.)",
      value: "Doctorate of Medicine (D.M.)",
    },
    {
      label: "Master of Chirurgiae (M.Ch)",
      value: "Master of Chirurgiae (M.Ch)",
    },
    { label: "DNB", value: "DNB" },
    {
      label: "Master of Dental Surgery (M.D.S.)",
      value: "Master of Dental Surgery (M.D.S.)",
    },
    {
      label: "Diploma in Otorhinolaryngology",
      value: "Diploma in Otorhinolaryngology",
    },
    { label: "Ayush Doctor", value: "Ayush Doctor" },
    {
      label: "Registered Medical Assistant (RMA)",
      value: "Registered Medical Assistant (RMA)",
    },
    {
      label: "Diploma in Child Health (D.C.H)",
      value: "Diploma in Child Health (D.C.H)",
    },
    {
      label: "Bachelor of Dental Surgery",
      value: "Bachelor of Dental Surgery",
    },
  ];

  const handleTreatmentDataChange = (fieldName: string, data: any) => {
    switch (fieldName) {
      case "speciality":
        const formattedSpecialityData = { id: data?.value, name: data?.label };
        setNewTreatmentPlan({
          ...newTreatmentPlan,
          speciality: formattedSpecialityData,
        });
        break;

      case "procedure": {
        const formattedProcedureData = {
          id: data?.value,
          name: data?.label,
          procedureAmount: null,
          procedureName: null,
        };
        const selectedProcedure = data?.data;
        const nestedSpecialities = selectedProcedure?.specialities || [];
        setProcedureSpecialities(nestedSpecialities);

        const autoSpeciality =
          nestedSpecialities?.length === 1
            ? {
                id: nestedSpecialities?.[0]?.specialityid,
                name: nestedSpecialities?.[0]?.speciality,
              }
            : {};

        setNewTreatmentPlan({
          ...newTreatmentPlan,
          procedure: formattedProcedureData,
          speciality: autoSpeciality,
          stratification: {},
        });
        if (
          patients?.fetchBasicDetails?.casesResponse?.portalMetaDataIds?.[0]
        ) {
          selectedProcedure?.isstratificationapplicable == "Y" &&
            dispatch(
              getStratifications({
                portalMetaDataId:
                  patients?.fetchBasicDetails?.casesResponse
                    ?.portalMetaDataIds?.[0],
                procedureCode: selectedProcedure?.procedurecode,
              })
            );
        }
        break;
      }

      case "procedureName":
        const formattedProcedureDataWithName = {
          ...newTreatmentPlan?.procedure,
          procedureName: data,
        };
        setNewTreatmentPlan({
          ...newTreatmentPlan,
          procedure: formattedProcedureDataWithName,
          stratification: {},
        });
        break;

      case "procedureAmount":
        const formattedProcedureDataWithAmount = {
          ...newTreatmentPlan?.procedure,
          procedureAmount: data,
        };
        setNewTreatmentPlan({
          ...newTreatmentPlan,
          procedure: formattedProcedureDataWithAmount,
          stratification: {},
        });
        break;

      case "stratification":
        const formattedStratificationData = {
          id: data?.value,
          name: data?.label,
        };
        // const formattedStratificationData = stratifications.find((item)=> item.stratificationid == value) || {};
        setNewTreatmentPlan({
          ...newTreatmentPlan,
          stratification: formattedStratificationData,
        });
        break;

      case "numberOfDaysPerUnits":
        setNewTreatmentPlan({
          ...newTreatmentPlan,
          numberOfDaysPerUnits: data,
        });
        break;

      case "ichiCode":
        // const formattedIchiCodeData = specialities.find((item)=> item.stratificationid == value) || {};
        // setNewTreatmentPlan({...newTreatmentPlan, ichiCode: value})
        break;

      default:
        break;
    }
  };

  const handleAddTreatmentPlan = (): void => {
    if (
      !newTreatmentPlan?.procedure ||
      !newTreatmentPlan?.speciality
      // !newTreatmentPlan?.numberOfDaysPerUnits
    ) {
      message.error("Please, fill all required field!");
      return;
    }
    const selectedMaster = findProcedureInMaster(
      procedures,
      newTreatmentPlan?.procedure
    );
    const formatedTreatmentPlanData = {
      speciality: newTreatmentPlan?.speciality,
      procedure: {
        id: newTreatmentPlan?.procedure?.id || null,
        name: newTreatmentPlan?.procedure?.name,
        procedureName: newTreatmentPlan?.procedure?.procedureName,
        procedureAmount: newTreatmentPlan?.procedure?.procedureAmount,
        implants:
          selectedMaster?.implants ||
          selectedMaster?.implantsList ||
          [],
        investigations: selectedMaster?.investigations || [],
        isimplantapplicable: selectedMaster?.isimplantapplicable,
      },
      stratification: newTreatmentPlan?.stratification || null,
      numberOfDaysPerUnits: newTreatmentPlan?.numberOfDaysPerUnits,
      // ichiCode : newTreatmentPlan?.ichiCode,
    };
    setTreatmentPlansData([
      ...treatmentPlansData,
      { ...formatedTreatmentPlanData },
    ]);
    setNewTreatmentPlan({
      speciality: {},
      procedure: {},
      stratification: {},
      numberOfDaysPerUnits: 1,
      // ichiCode: "",
    });
    setProcedureSpecialities([]);
  };

  const DiagonsisColumns = [
    {
      title: "S.No.",
      dataIndex: "no",
      key: "no",
      width: 80,
      render: (_: string, r_: DiagnosisData, index: number) => (
        <span style={{ fontWeight: "bold" }}>{index + 1}</span>
      ),
    },
    {
      title: "Diagnosis",
      dataIndex: "diagnosis",
      key: "diagnosis",
      render: (text: string) => (
        <span style={{ fontWeight: "bold" }}>{text}</span>
      ),
    },
    {
      title: "Diagnosis Type",
      dataIndex: "type",
      key: "type",
      render: (text: string) => (
        <span style={{ fontWeight: "bold" }}>{text}</span>
      ),
    },
    {
      title: "Action",
      dataIndex: "action",
      key: "action",
      render: (_: any, record: DiagnosisData, index: number) => (
        <Space size="middle">
          <Button
            icon={
              <DeleteOutlined
                style={{
                  color: "rgb(0, 84, 157)",
                  fontSize: "17px",
                  cursor: "pointer",
                }}
                disabled={
                  ayushBPreAuth?.portalData?.casePreAuthOthersResponse
                    ?.casePreAuthResponse?.submitted
                }
              />
            }
            onClick={() => handleDeleteDiagnosis(index)}
            disabled={
              ayushBPreAuth?.portalData?.casePreAuthOthersResponse
                ?.casePreAuthResponse?.submitted
            }
          />
        </Space>
      ),
    },
  ];

  const TreatmentPlanColumns = [
    {
      title: "S.No.",
      dataIndex: "no",
      key: "no",
      width: 80,
      render: (_: string, r_: TreatmentPlan, index: number) => (
        <span style={{ fontWeight: "bold" }}>{index + 1}</span>
      ),
    },
    {
      title: "Speciality",
      dataIndex: "speciality",
      key: "speciality",
      render: (text: JsonObject) => (
        <span style={{ fontWeight: "bold" }}>{text?.name}</span>
      ),
    },
    {
      title: "Procedure",
      dataIndex: "procedure",
      key: "procedure",
      render: (text: JsonObject) => (
        <span style={{ fontWeight: "bold" }}>{text?.name}</span>
      ),
    },
    {
      title: "Stratification",
      dataIndex: "stratification",
      key: "stratification",
      render: (text: JsonObject) => (
        <span style={{ fontWeight: "bold" }}>{text?.name}</span>
      ),
    },
    {
      title: "No. of Days/Units",
      dataIndex: "numberOfDaysPerUnits",
      key: "numberOfDaysPerUnits",
      render: (text: string) => (
        <span style={{ fontWeight: "bold" }}>{text}</span>
      ),
    },
    // {
    //     title: "ICHI Code",
    //     dataIndex: "ichiCode",
    //     key: "ichiCode",
    //     render: (text: string) => <span style={{ fontWeight: "bold" }}>{text}</span>,
    // },
    {
      title: "Action",
      dataIndex: "action",
      key: "action",
      render: (_: any, record: TreatmentPlan, index: number) => (
        <Space size="middle">
          <Button
            icon={
              <DeleteOutlined
                style={{
                  color: "rgb(0, 84, 157)",
                  fontSize: "17px",
                  cursor: "pointer",
                }}
                disabled={
                  ayushBPreAuth?.portalData?.casePreAuthOthersResponse
                    ?.casePreAuthResponse?.submitted
                }
              />
            }
            onClick={() => handleDeleteTreatmentPlan(index)}
            disabled={
              ayushBPreAuth?.portalData?.casePreAuthOthersResponse
                ?.casePreAuthResponse?.submitted
            }
          />
        </Space>
      ),
    },
  ];

  return (
    <>
      <Form
        layout="vertical"
        form={form}
        initialValues={{
          diagnosisType: "Primary",
        }}
      >
        <MedicalInformation
          isDisabled={
            ayushBPreAuth?.portalData?.casePreAuthOthersResponse
              ?.casePreAuthResponse?.submitted
          }
        />

        <AdmissionInformation
          form={form}
          isDisabled={
            ayushBPreAuth?.portalData?.casePreAuthOthersResponse
              ?.casePreAuthResponse?.submitted
          }
          admissionDateValue={admissionDateValue}
          dateFormat={dateFormat}
        />

        <h2>TREATMENT</h2>

        <h3 style={{ margin: "14px 0" }}>DIAGNOSIS</h3>
        <Row gutter={[16, 16]}>
          <Col xs={24} sm={12} md={7} lg={7} xl={7}>
            <Form.Item label="SEARCH DIAGNOSIS">
              <Search
                placeholder="Type here"
                loading={ayushBPreAuth?.isFetchingData}
                onSearch={(value) => handleCategorySearch(value)}
                disabled={
                  ayushBPreAuth?.portalData?.casePreAuthOthersResponse
                    ?.casePreAuthResponse?.submitted
                }
              />
            </Form.Item>
          </Col>
          <Col xs={24} sm={12} md={7} lg={7} xl={7}>
            <Form.Item label="SELECT DIAGNOSIS" name="selectedDiagnosis">
              <Select
                showSearch
                placeholder="Select"
                style={{ width: "100%" }}
                value={
                  newDiagnosis?.diagnosisCode !== "" &&
                  newDiagnosis?.diagnosisCode
                    ? newDiagnosis?.diagnosisCode
                    : null
                }
                onChange={handleDiagnosisSelect}
                disabled={
                  !(diagnosisOptions?.length > 0) ||
                  disabledForm ||
                  ayushBPreAuth?.portalData?.casePreAuthOthersResponse
                    ?.casePreAuthResponse?.submitted
                }
                filterOption={(input, option) =>
                  (option?.label as string)
                    ?.toLowerCase()
                    .includes(input.toLowerCase()) ||
                  (option?.value as string)
                    ?.toLowerCase()
                    .includes(input.toLowerCase()) ||
                  (option?.data?.theCode as string)
                    ?.toLowerCase()
                    .includes(input.toLowerCase())
                }
              >
                {diagnosisOptions?.map((option, index) => {
                  const fullText = `${option?.title} | (${option?.theCode})`;
                  return (
                    <Option
                      key={index}
                      value={option?.theCode}
                      label={fullText}
                      data={option}
                    >
                      {fullText}
                    </Option>
                  );
                })}
              </Select>
            </Form.Item>
          </Col>
          <Col xs={24} sm={12} md={7} lg={7} xl={7}>
            <Form.Item
              label="DIAGNOSIS TYPE"
              name="diagnosisType"
              //   rules={[
              //     { required: true, message: "Please select diagnosis type" },
              //   ]}
            >
              <Radio.Group
                value={newDiagnosis?.type || null}
                onChange={(e) =>
                  setNewDiagnosis((prev) => ({ ...prev, type: e.target.value }))
                }
                disabled={
                  ayushBPreAuth?.portalData?.casePreAuthOthersResponse
                    ?.casePreAuthResponse?.submitted
                }
              >
                {!diagnosisData?.some((item) => item?.type == "Primary") && (
                  <Radio value="Primary">Primary</Radio>
                )}
                <Radio value="Secondary">Secondary</Radio>
              </Radio.Group>
            </Form.Item>
          </Col>

          <Col span={2} style={{ display: "flex", alignItems: "center" }}>
            <Button
              style={{
                width: "100px",
                color: "white",
                backgroundColor: "rgb(0, 84, 157)",
              }}
              onClick={handleAddDiagnosis}
              disabled={
                !newDiagnosis.diagnosis ||
                !newDiagnosis.type ||
                ayushBPreAuth?.portalData?.casePreAuthOthersResponse
                  ?.casePreAuthResponse?.submitted
              }
            >
              ADD
            </Button>
          </Col>
          <Table
            dataSource={diagnosisData}
            columns={DiagonsisColumns}
            pagination={false}
            className="claim-table"
            bordered
            style={{
              width: "100%",
              // margin: "10px auto",
              textAlign: "center",
            }}
          />
        </Row>

        <h3 style={{ margin: "14px 0" }}>TREATMENT PLAN</h3>
        {!isUnspecifiedProcedure ? (
          <>
            <Row gutter={[16, 16]}>
              <Col xs={24} sm={12} md={7} lg={7} xl={7}>
                <Form.Item label="Procedure">
                  <Select
                    showSearch
                    style={{ width: "100%" }}
                    placeholder="Select a procedure"
                    disabled={
                      ayushBPreAuth?.portalData?.casePreAuthOthersResponse
                        ?.casePreAuthResponse?.submitted
                    }
                    optionFilterProp="children"
                    value={newTreatmentPlan?.procedure?.id || null}
                    onChange={(_: string, option: any) =>
                      handleTreatmentDataChange("procedure", option)
                    }
                    filterOption={(input, option) =>
                      (option?.label as string)
                        ?.toLowerCase()
                        .includes(input.toLowerCase()) ||
                      (option?.value as string)
                        ?.toLowerCase()
                        .includes(input.toLowerCase()) ||
                      (option?.data?.procedurecode as string)
                        ?.toLowerCase()
                        .includes(input.toLowerCase())
                    }
                  >
                    {procedures?.map((procedure: any, index: number) => (
                      <Option
                        key={index}
                        value={procedure?.procedurecode}
                        label={procedure?.procedurename}
                        data={procedure}
                      >
                        {procedure?.procedurename}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>

              <Col xs={24} sm={12} md={7} lg={7} xl={7}>
                <Form.Item label="Speciality">
                  <Select
                    showSearch
                    placeholder={
                      newTreatmentPlan?.procedure?.id
                        ? "Select"
                        : "Select procedure first"
                    }
                    style={{ width: "100%" }}
                    disabled={
                      !newTreatmentPlan?.procedure?.id ||
                      ayushBPreAuth?.portalData?.casePreAuthOthersResponse
                        ?.casePreAuthResponse?.submitted
                    }
                    optionFilterProp="children"
                    value={newTreatmentPlan?.speciality?.id || null}
                    onChange={(_: string, option: any) =>
                      handleTreatmentDataChange("speciality", option)
                    }
                    filterOption={(input, option) =>
                      (option?.label as string)
                        ?.toLowerCase()
                        .includes(input.toLowerCase()) ||
                      (option?.value as string)
                        ?.toLowerCase()
                        .includes(input.toLowerCase()) ||
                      (option?.data?.specialitycode as string)
                        ?.toLowerCase()
                        .includes(input.toLowerCase())
                    }
                  >
                    {procedureSpecialities?.map((speciality: any, index: number) => (
                      <Option
                        key={index}
                        value={speciality?.specialityid}
                        label={speciality?.speciality}
                        data={speciality}
                      >
                        {speciality?.speciality}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>

              {newTreatmentPlan?.procedure?.name
                ?.toLowerCase()
                ?.includes("unspecified") && (
                <>
                  <Col span={6}>
                    <Form.Item label="Procedure Name">
                      <Input
                        placeholder="Enter Procedure Name"
                        value={newTreatmentPlan?.procedure?.procedureName || ""}
                        disabled={
                          ayushBPreAuth?.portalData?.casePreAuthOthersResponse
                            ?.casePreAuthResponse?.submitted
                        }
                        onChange={(e) =>
                          handleTreatmentDataChange(
                            "procedureName",
                            e?.target?.value || ""
                          )
                        }
                      />
                    </Form.Item>
                  </Col>

                  <Col span={6}>
                    <Form.Item label="Procedure Amount">
                      <InputNumber
                        placeholder="Enter Procedure Amount"
                        value={newTreatmentPlan?.procedure?.amount}
                        disabled={
                          ayushBPreAuth?.portalData?.casePreAuthOthersResponse
                            ?.casePreAuthResponse?.submitted
                        }
                        onChange={(value) =>
                          handleTreatmentDataChange(
                            "procedureAmount",
                            value || ""
                          )
                        }
                        min={0}
                        max={500000}
                      />
                    </Form.Item>
                  </Col>
                </>
              )}

              {procedures?.find(
                (i: any) => i?.procedurecode == newTreatmentPlan?.procedure?.id
              )?.isstratificationapplicable === "Y" && (
                <Col xs={24} sm={12} md={7} lg={7} xl={7}>
                  <Form.Item label="Stratification">
                    <Select
                      showSearch
                      placeholder="Select"
                      disabled={
                        ayushBPreAuth?.portalData?.casePreAuthOthersResponse
                          ?.casePreAuthResponse?.submitted
                      }
                      style={{ width: "100%" }}
                      optionFilterProp="children"
                      value={newTreatmentPlan?.stratification?.id || null}
                      onChange={(_: string, option: any) =>
                        handleTreatmentDataChange("stratification", option)
                      }
                      filterOption={(input, option) =>
                        (option?.label as string)
                          ?.toLowerCase()
                          .includes(input.toLowerCase()) ||
                        (option?.value as string)
                          ?.toLowerCase()
                          .includes(input.toLowerCase()) ||
                        (option?.data?.stratificationcode as string)
                          ?.toLowerCase()
                          .includes(input.toLowerCase())
                      }
                    >
                      {stratifications?.map((stratification, index) => (
                        <Option
                          key={index}
                          value={stratification?.stratificationCode}
                          label={stratification?.stratificationName}
                          data={stratification}
                        >
                          {stratification?.stratificationName}
                        </Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>
              )}

              <Col xs={24} sm={12} md={7} lg={7} xl={7}>
                <Form.Item label="No. of Days/Units">
                  <InputNumber
                    placeholder="Enter Detail"
                    value={newTreatmentPlan?.numberOfDaysPerUnits || 1}
                    disabled={
                      ayushBPreAuth?.portalData?.casePreAuthOthersResponse
                        ?.casePreAuthResponse?.submitted
                    }
                    min={0}
                    onChange={(value) =>
                      handleTreatmentDataChange(
                        "numberOfDaysPerUnits",
                        value || ""
                      )
                    }
                  />
                </Form.Item>
              </Col>
              {/* </Row>

            <Row> */}
              <Col span={2} style={{ display: "flex", justifyContent: "end" }}>
                <Button
                  style={{
                    width: "100px",
                    color: "white",
                    backgroundColor: "rgb(0, 84, 157)",
                    marginTop: "29px",
                  }}
                  onClick={handleAddTreatmentPlan}
                  disabled={
                    !newTreatmentPlan?.procedure?.id ||
                    !newTreatmentPlan?.speciality?.id ||
                    ayushBPreAuth?.portalData?.casePreAuthOthersResponse
                      ?.casePreAuthResponse?.submitted
                  }
                >
                  ADD
                </Button>
              </Col>
            </Row>
          </>
        ) : (
          <div style={{ textAlign: "center", marginTop: 16, marginBottom: 16 }}>
            <Text type="danger">
              No more TreatmentPlan after selecting the unspecified one
            </Text>
          </div>
        )}

        <Table
          dataSource={treatmentPlansData}
          columns={TreatmentPlanColumns}
          pagination={false}
          className="claim-table"
          bordered
          style={{
            width: "100%",
            // margin: "10px auto",
            textAlign: "center",
          }}
        />

        {showImplantSection && (
          <>
            <h3 style={{ margin: "28px 0 14px" }}>IMPLANT</h3>
            <div style={{ display: "flex", justifyContent: "flex-end" }}>
              <Button
                type="primary"
                style={{
                  backgroundColor: "rgb(0, 84, 157)",
                  color: "#fff",
                  boxShadow: "0px 2px 8px 0px #00000040",
                  margin: "14px 0",
                }}
                onClick={() => handleModalOpen("implant")}
                disabled={
                  ayushBPreAuth?.portalData?.casePreAuthOthersResponse
                    ?.casePreAuthResponse?.submitted
                }
              >
                Upload document
              </Button>
            </div>
            <Table
              dataSource={uploadedImplantFileList || []}
              className="claim-table"
              columns={uploadedImplantFileColumns}
              pagination={false}
              bordered
              style={{
                width: "100%",
                // margin: "10px auto",
                textAlign: "center",
              }}
            />
          </>
        )}

        {showInvestigationSection && (
          <>
            <h3 style={{ margin: "28px 0 14px" }}>INVESTIGATIONS</h3>
            <div style={{ display: "flex", justifyContent: "flex-end" }}>
              <Button
                type="primary"
                style={{
                  backgroundColor: "rgb(0, 84, 157)",
                  color: "#fff",
                  boxShadow: "0px 2px 8px 0px #00000040",
                  margin: "14px 0",
                }}
                onClick={() => handleModalOpen("investigation")}
                disabled={
                  ayushBPreAuth?.portalData?.casePreAuthOthersResponse
                    ?.casePreAuthResponse?.submitted
                }
              >
                Upload document
              </Button>
            </div>
            <Table
              dataSource={uploadedInvestigationFileList || []}
              columns={uploadedFileColumns}
              pagination={false}
              className="claim-table"
              bordered
              style={{
                width: "100%",
                // margin: "10px auto",
                textAlign: "center",
              }}
            />
          </>
        )}

        <div style={{ marginBottom: "24px", marginTop: "14px" }}>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              width: "100%",
              fontSize: "18px",
              marginBottom: "6px",
              fontWeight: "bold",
            }}
          >
            <span style={{ textDecoration: "underline" }}>
              Care Team Details
            </span>
          </div>

          <Form.Item
            label="Select Doctor"
            name="selectedDoctor"
            rules={[{ required: true, message: "Please select an option" }]}
          >
            <Select
              placeholder="Select a doctor"
              style={{ width: "100%" }}
              value={selectedDoctor}
              onChange={handleDoctorChange}
              showSearch
              optionFilterProp="children"
              disabled={
                ayushBPreAuth?.portalData?.casePreAuthOthersResponse
                  ?.casePreAuthResponse?.submitted
              }
            >
              {/* {doctors?.map((doctor: any, index: number) => (
                <Option key={index} value={doctor?.docid}>
                  {doctor?.docname}
                </Option>
              ))} */}
              <Option value="OTHER">Other</Option>
            </Select>
          </Form.Item>

          {selectedDoctor ? (
            <Row gutter={16} style={{ marginBottom: 16 }}>
              <Col xs={24} sm={12} md={6}>
                <Form.Item
                  label="Doctor Name"
                  name="doctorName"
                  rules={[
                    { required: true, message: "Please enter doctor name" },
                    { whitespace: true, message: "Name cannot be empty" },
                  ]}
                >
                  <Input
                    placeholder="Doctor Name"
                    disabled={
                      ayushBPreAuth?.portalData?.casePreAuthOthersResponse
                        ?.casePreAuthResponse?.submitted
                    }
                  />
                </Form.Item>
              </Col>

              <Col xs={24} sm={12} md={6}>
                <Form.Item
                  label="Registration ID"
                  name="doctorRegistrationId"
                  rules={[
                    {
                      required: true,
                      message: "Please enter registration ID",
                    },
                    {
                      whitespace: true,
                      message: "Registration ID cannot be empty",
                    },
                  ]}
                >
                  <Input
                    placeholder="Registration ID"
                    disabled={
                      ayushBPreAuth?.portalData?.casePreAuthOthersResponse
                        ?.casePreAuthResponse?.submitted
                    }
                  />
                </Form.Item>
              </Col>

              <Col xs={24} sm={12} md={6}>
                <Form.Item
                  label="Qualification"
                  name="doctorQualification"
                  rules={[
                    {
                      required: true,
                      message: "Please select qualification",
                    },
                  ]}
                >
                  <Select
                    options={qualificationOptions}
                    placeholder="Select qualification"
                    showSearch
                    allowClear
                    disabled={
                      ayushBPreAuth?.portalData?.casePreAuthOthersResponse
                        ?.casePreAuthResponse?.submitted
                    }
                  />
                </Form.Item>
              </Col>

              <Col xs={24} sm={12} md={6}>
                <Form.Item
                  label="Contact Number"
                  name="doctorMobileNo"
                  rules={[
                    {
                      required: true,
                      message: "Please enter contact number",
                    },
                    {
                      pattern: /^[0-9]{10}$/,
                      message: "Please enter valid 10-digit number",
                    },
                  ]}
                >
                  <Input
                    placeholder="Contact Number"
                    maxLength={10}
                    disabled={
                      ayushBPreAuth?.portalData?.casePreAuthOthersResponse
                        ?.casePreAuthResponse?.submitted
                    }
                  />
                </Form.Item>
              </Col>
            </Row>
          ) : null}
        </div>
      </Form>

      {loading ? (
        <div
          style={{
            margin: "auto",
            width: "100%,",
            display: "flex",
            justifyContent: "center",
          }}
        >
          <Spin />
        </div>
      ) : (
        documentRequestResponseDocuments?.["requestedDocuments"]?.length >
          0 && (
          <>
            <DocumentUpload
              documentTypes={documentTypes}
              documentUrls={documentUrls}
              handleFileChange={handleFileChange}
              handleOpen={handleOpen}
              documentRequestResponseDocuments={
                documentRequestResponseDocuments
              }
              portalSubmission={
                ayushBPreAuth?.portalData?.casePreAuthOthersResponse
                  ?.casePreAuthResponse?.submitted
              }
              isApproved={isApproved}
              uploadFileList={uploadFileList}
              isIntimated={
                ayushBPreAuth?.portalData?.casePreAuthOthersResponse
                  ?.casePreAuthResponse?.intimated
              }
              headerExtra={
                <Button
                  type="primary"
                  style={{
                    backgroundColor: "rgb(0, 76, 143)",
                    color: "#fff",
                    boxShadow: "0px 2px 8px 0px #00000040",
                  }}
                  onClick={() => handleModalOpen("extraRequest")}
                  disabled={
                    ayushBPreAuth?.portalData?.casePreAuthOthersResponse
                      ?.casePreAuthResponse?.submitted
                  }
                >
                  Upload additional document
                </Button>
              }
            />
          </>
        )
      )}

      {documentRequestResponseDocuments?.["responseDocuments"]?.length > 0 && (
        <ResponseDocumentUpload
          documentTypes={documentTypes}
          documentUrls={documentUrls}
          handleFileChange={handleFileChange}
          handleOpen={handleOpen}
          portalSubmission={
            ayushBPreAuth?.portalData?.casePreAuthOthersResponse
              ?.casePreAuthResponse?.submitted
          }
          documentRequestResponseDocuments={documentRequestResponseDocuments}
          handleSaveData={handleSaveData}
          currentStage={preAuth?.stepperData?.currentVisitStage}
          activeKey={activeKey}
          uploadFileList={uploadFileList}
        />
      )}

      <div
        style={{
          marginTop: 20,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          gap: "30px",
          borderTop: "1px solid #D9D9D9",
          padding: "15px 20px",
        }}
      >
        {
          <>
            {!ayushBPreAuth?.portalData?.casePreAuthOthersResponse
              ?.casePreAuthResponse?.submitted ? (
              <>
                {ayushBPreAuth?.portalData?.casePreAuthOthersResponse
                  ?.casePreAuthResponse?.id &&
                !ayushBPreAuth?.portalData?.casePreAuthOthersResponse
                  ?.casePreAuthResponse?.initiated ? (
                  // && !props?.portalData?.casePreAuthCghs?.casePreAuthResponse
                  //   ?.approved
                  // && !(
                  //   auth?.role?.role == "FO_STAFF" &&
                  //   props?.portalData?.casePreAuthCghs?.casePreAuthResponse
                  //     ?.intimated
                  // )
                  <div style={{ width: "16%" }}>
                    <Button
                      type="primary"
                      style={{
                        backgroundColor: "rgb(0, 76, 143)",
                        color: "#fff",
                        boxShadow: "0px 2px 8px 0px #00000040",
                        width: "100%",
                      }}
                      // onClick={props?.handleUpdateAsDraft}
                      onClick={() => handleSaveConfirmationModal("update")}
                    >
                      UPDATE
                    </Button>
                  </div>
                ) : (
                  !ayushBPreAuth?.portalData?.casePreAuthOthersResponse
                    ?.casePreAuthResponse?.id && (
                    <div style={{ width: "16%" }}>
                      <Button
                        type="primary"
                        style={{
                          backgroundColor: "rgb(0, 76, 143)",
                          color: "#fff",
                          boxShadow: "0px 2px 8px 0px #00000040",
                          width: "100%",
                        }}
                        // onClick={props?.handleSaveAsDraft}
                        onClick={() => handleSaveConfirmationModal("save")}
                      >
                        SAVE
                      </Button>
                    </div>
                  )
                )}

                {hasFunctionality("casePreAuthIntimate") &&
                  !ayushBPreAuth?.portalData?.casePreAuthOthersResponse
                    ?.casePreAuthResponse?.intimated &&
                  !ayushBPreAuth?.portalData?.casePreAuthOthersResponse
                    ?.casePreAuthResponse?.initiated &&
                  !ayushBPreAuth?.portalData?.casePreAuthOthersResponse
                    ?.casePreAuthResponse?.approved && (
                    <div style={{ width: "16%" }}>
                      <Button
                        style={{
                          backgroundColor: "rgb(0, 76, 143)",
                          color: "#fff",
                          boxShadow: "0px 2px 8px 0px #00000040",
                          width: "100%",
                        }}
                        className="me-2"
                        // onClick={() => handleSaveIhx()}
                        onClick={() => handleSaveConfirmationModal("intimate")}
                      >
                        Send To QC
                      </Button>
                    </div>
                  )}

                {hasFunctionality("preAuthApprover") &&
                  !ayushBPreAuth?.portalData?.casePreAuthOthersResponse
                    ?.casePreAuthResponse?.initiated &&
                  !ayushBPreAuth?.portalData?.casePreAuthOthersResponse
                    ?.casePreAuthResponse?.approved &&
                  !ayushBPreAuth?.portalData?.casePreAuthOthersResponse
                    ?.casePreAuthResponse?.submitted && (
                    <div style={{ width: "16%" }}>
                      <Button
                        loading={isApprovedInitiated}
                        className="me-2"
                        // onClick={handleApprovePreAuth}
                        onClick={() => handleSaveConfirmationModal("approve")}
                        disabled={isApproved}
                        // style={{ }}
                        style={{
                          backgroundColor: "rgb(0, 76, 143)",
                          color: "#fff",
                          boxShadow: "0px 2px 8px 0px #00000040",
                          width: "100%",
                          opacity: !isApproved ? 1 : 0.5,
                          pointerEvents: !isApproved ? "auto" : "none",
                        }}
                        // style={{display: "flex", alignItems: "center", background: "rgb(0, 84, 157)", border: "1px solid rgb(0, 84, 157)", boxShadow: "0px 2px 8px 0px #00000040", borderRadius: "10px", padding: "12px 25px"}}
                      >
                        QC Approve
                      </Button>
                    </div>
                  )}

                {hasFunctionality("casePreAuthSubmission") &&
                  !ayushBPreAuth?.portalData?.casePreAuthOthersResponse
                    ?.casePreAuthResponse?.initiated &&
                  !ayushBPreAuth?.portalData?.casePreAuthOthersResponse
                    ?.casePreAuthResponse?.submitted && (
                    <div style={{ width: "16%" }}>
                      <Button
                        type="primary"
                        style={{
                          backgroundColor: "rgb(0, 76, 143)",
                          color: "#fff",
                          boxShadow: "0px 2px 8px 0px #00000040",
                          width: "100%",
                        }}
                        onClick={() => handleSaveConfirmationModal("submit")}
                      >
                        {patients?.fetchBasicDetails?.casesResponse
                          ?.integratedWithPortal
                          ? "Initiate"
                          : "Submit Manually"}
                      </Button>
                    </div>
                  )}
              </>
            ) : (
              <></>
            )}
          </>
        }
      </div>
    </>
  );
};

export default React.memo(PreAuthAyushman);
